import { setFeatureFlag, FEATURE_FLAG_KEYS, type FeatureFlagKey } from '@repo/feature-flag';

import { FEATURE_FLAG_OVERRIDES_KEY } from '@shared/constants/featureFlagOverrides';

const isValidFeatureFlagKey = (key: string): key is FeatureFlagKey =>
  (FEATURE_FLAG_KEYS as readonly string[]).includes(key);

export const applyStoredFeatureFlagOverrides = (): void => {
  try {
    const stored = sessionStorage.getItem(FEATURE_FLAG_OVERRIDES_KEY);
    if (stored) {
      const overrides = JSON.parse(stored) as Record<string, boolean>;
      for (const [key, value] of Object.entries(overrides)) {
        if (isValidFeatureFlagKey(key)) {
          setFeatureFlag(key, value);
        }
      }
    }
  } catch {
    // ignore malformed sessionStorage data
  }
};
